import { logger } from 'app/core/util/logger';
import { util } from 'app/core/util/util';
import { Definition, isDefinition } from './definition.interface';
import * as actions from './definitions.actions';
import { initialState } from './definitions.model';
import { createReducer, on } from '@ngrx/store';

const prepareArray = (keyValueObject: { [key: string]: string }) => {
  if (keyValueObject == null) {
    logger.error('No key value object in definitions');
    return [];
  }
  const result = Object.keys(keyValueObject).map(key => {
    // check if name property is not an object
    // if it is, then get name property from this object
    let name = keyValueObject[key];
    let relocationAllowed;
    if (isDefinition(name)) {
      relocationAllowed = name['relocationAllowed'];
      name = name.name;
    }
    if (name === '') {
      name = '-';
    }
    let place = { id: key, name, defaultValue: false };
    if (typeof relocationAllowed === 'boolean') {
      place['relocationAllowed'] = relocationAllowed;
    }
    return place;
  });
  // Mark first one as default
  if (result.length > 0) {
    result.splice(0, 1, Object.assign({}, result[0], { defaultValue: true }));
  }
  return result.sort((o1, o2) => (o1.defaultValue ? -1 : o2.defaultValue ? 1 : o1.name > o2.name ? 1 : o1.name < o2.name ? -1 : 0));
};

export const reducer = createReducer(
  initialState,
  on(actions.definitionsLoadAction, state => ({
    ...state,
    loading: true,
    failed: false,
    loaded: false,
  })),
  on(actions.definitionsLoadSuccessAction, (state, { definitions, language }) => {
    return Object.assign({}, state, {
      language,
      flow: {
        status: prepareArray(definitions.flowStatus),
        type: prepareArray(definitions.orderType).filter((def: Definition) => ['CUS-CUS-DSMV', 'CUS-CUS-MOV'].indexOf(def.id) >= 0),
        wholesaler: prepareArray(definitions.wholeSaler),
      },
      order: {
        status: prepareArray(definitions.orderStatus),
        type: prepareArray(definitions.orderType).filter((def: Definition) => ['CUS-CUS-DSMV', 'CUS-CUS-MOV'].indexOf(def.id) < 0),
        logisticsVarietyPacking: prepareArray(definitions.logisticVarietyPacking),
        packingPerPallet: prepareArray(definitions.packingsPerPallet),
        incoterm: prepareArray(definitions.incoTerm).map(i => {
          return { id: i.id, name: i.id };
        }),
      },
      pallet: {
        type: prepareArray(definitions.palletId),
      },
      packing: {
        type: prepareArray(definitions.packingId),
        status: prepareArray(definitions.packingStatus),
      },
      transport: {
        type: prepareArray(definitions.transportType).filter(transportType => transportType.id.charAt(0) === 'Z'),
      },
      global: {
        type: prepareArray(definitions.globalType),
        brick: prepareArray(definitions.brick),
      },
      invoices: {
        invoiceTypes: prepareArray(definitions.invoiceType),
      },
      places: prepareArray(definitions.depot),
      loaded: true,
      failed: false,
      loading: false,
    });
  }),
  on(actions.definitionsLoadFailAction, (state, {statusText}) => ({
    ...state,
    loading: false,
    failed: true,
    failMessage: statusText,
  }))
);
